import {
  getIssueViewerFeed,
  timelineItemTypesForIssueViewerFeed,
} from '@github-ui/preheat-issues-manager/issue-viewer-storage-key'

import {getInitialTimelinePageSize} from '../constants/values'
import type {IssueViewerViewQuery$variables} from './__generated__/IssueViewerViewQuery.graphql'

type IssueViewerViewQueryVariableOptions = Pick<IssueViewerViewQuery$variables, 'owner' | 'repo' | 'number'> &
  Partial<Pick<IssueViewerViewQuery$variables, 'allowedOwner' | 'hideTimeline'>>

export function buildIssueViewerViewQueryVariables({
  owner,
  repo,
  number,
  allowedOwner,
  hideTimeline,
}: IssueViewerViewQueryVariableOptions): IssueViewerViewQuery$variables {
  const timelineItemTypes = timelineItemTypesForIssueViewerFeed(getIssueViewerFeed())

  return {
    owner,
    repo,
    number,
    allowedOwner: allowedOwner ?? null,
    hideTimeline: hideTimeline ?? false,
    count: getInitialTimelinePageSize(),
    skip: null,
    ...(timelineItemTypes === undefined ? {} : {timelineItemTypes}),
  }
}
